import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../../../shared/API/apiClient";
import "../../../styles/pages/submissionTracker.css";

const ImportReferencePage = () => {

    const navigate = useNavigate();
    const [copyMessage, setCopyMessage] = useState("");
    const [loading, setLoading] = useState(true);

    const [search, setSearch] = useState("");

    const [activities, setActivities] = useState([]);

    const [filteredActivities, setFilteredActivities] = useState([]);

    const [error, setError] = useState("");
    const [selectedActivity, setSelectedActivity] = useState(null);

    const copyToClipboard = (text, message) => {

    navigator.clipboard.writeText(text);

    setCopyMessage(message);

    setTimeout(() => setCopyMessage(""), 2000);

};

    useEffect(() => {

        loadReferenceData();

    }, []);

    useEffect(() => {

    if (!search.trim()) {

        setFilteredActivities(activities);

        if (activities.length > 0) {
            setSelectedActivity(activities[0]);
        }

        return;
    }

    const keyword = search.toLowerCase();

    const filtered = activities.filter(activity =>
        activity.activity_name
            .toLowerCase()
            .includes(keyword)
    );

    setFilteredActivities(filtered);

    if (filtered.length > 0) {
        setSelectedActivity(filtered[0]);
    } else {
        setSelectedActivity(null);
    }

}, [search, activities]);

    const loadReferenceData = async () => {

        try {

            setLoading(true);

            const response = await apiClient.get(
                "/api/activity/import/reference-data"
            );

            const data = response.data.activities || [];

            setActivities(data);

            setFilteredActivities(data);

            if (data.length > 0) {
                setSelectedActivity(data[0]);
            }

        } catch (err) {

            console.error(err);

            setError("Unable to load reference data.");

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="dash-page">

            <div className="iad-page-header">

                <div className="dash-page-subtitle">
                    ENVIRONMENT & CARBON
                </div>

                <div className="dash-page-title">
                    Reference Values
                </div>

                <div className="dash-page-subtitle">
                    View all valid activities and values before preparing your import file.
                </div>

            </div>

            <div className="filter-card">

                <div className="filter-group" style={{ flex: 1 }}>

                    <label>

                        Search Activity

                    </label>

                    <input
                        className="filter-input"
                        placeholder="Search Activity..."
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />

                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "end"
                    }}
                >

                    <button
                        className="org-btn-cancel"
                        onClick={() => navigate("/dashboard/import")}
                    >
                        Back
                    </button>

                </div>

            </div>

            {loading && (

                <div className="chart-card">

                    Loading reference data...

                </div>

            )}

            {!loading && error && (

                <div className="chart-card">

                    {error}

                </div>

            )}
{copyMessage && (

    <div className="copy-toast">

        <i className="fa-solid fa-circle-check"></i>

        {copyMessage}

    </div>

)}

            {!loading && !error && (

              

                <div className="reference-layout">

    <div className="reference-left">

        {filteredActivities.map(activity => (

            <div
                key={activity.activity_id}
                className={`reference-item ${
                    selectedActivity?.activity_id === activity.activity_id
                        ? "active"
                        : ""
                }`}
                onClick={() => setSelectedActivity(activity)}
            >

                {activity.activity_name}

            </div>

        ))}

    </div>

    <div className="reference-right">
  {!selectedActivity?(
    <div className="reference-empty">Select an activity to view reference values.</div>
  ):(
    <>
      <div className="reference-header">
  <div>
    <h2>{selectedActivity.activity_name}</h2>
    <div className="reference-unit">Unit : <strong>{selectedActivity.unit}</strong></div>
  </div>
  <div className="reference-count">

    {selectedActivity.attributes.reduce(

        (total, attribute) => total + attribute.values.length,

        0

    )} Reference Value(s)

</div>
  {selectedActivity.has_reference_values&&(
    <button
      className="org-btn-save"
      onClick={()=>{
        let text="";
        selectedActivity.attributes.forEach(attribute=>{
          text+=`${attribute.field_label}\n${attribute.values.join("\n")}\n\n`;
        });
        copyToClipboard(
    text,
    "All reference values copied."
);
      }}
    >
      <i className="fa-solid fa-copy"></i>&nbsp;Copy All
    </button>
  )}
</div>

      {!selectedActivity.has_reference_values?(
        <div className="reference-empty">No reference values required for this activity.</div>
      ):selectedActivity.attributes.map(attribute=>(
        <div key={attribute.field_key} className="reference-block">
          <div className="reference-block-header">
            <h4>{attribute.field_label}</h4>
            <button className="org-btn-save" onClick={() =>
    copyToClipboard(
        attribute.values.join("\n"),
        "Reference values copied."
    )
}>Copy Values</button>
          </div>

          <div className="reference-values">
            {attribute.values.map((value,index)=>(
              <span key={index} className="reference-chip">{value}</span>
            ))}
          </div>
        </div>
      ))}
    </>
  )}
</div>

</div>

            )}

        </div>

    );

};

export default ImportReferencePage;